// Site Nav

import './index.scss';

export default class SiteNav {
  constructor(root) {
    this.root = root;

    this.siteHeader = document.querySelector('.site-header');

    this.overlay = this.root.querySelector('.sn-overlay');
    this.overlay.addEventListener('click', this.hideMenu.bind(this));

    let menu = this.root.querySelector('.sn-menu');
    if (menu) { this.menu = menu; }

    document.querySelectorAll('[data-func="show-menu"]').forEach((link) => {
      link.addEventListener('click', this.showMenu.bind(this));
    });

    document.querySelectorAll('[data-func="hide-menu"]').forEach((link) => {
      link.addEventListener('click', this.hideMenu.bind(this));
    });

    this.root.querySelectorAll('.sn-item-a.has-children > .page-name').forEach((link) => {
      let list = link.parentNode;

      link.addEventListener('click', (event) => {
        if (window.innerWidth < window.breakpoint.md_sh) { return; }
        event.preventDefault();

        if (list.classList.contains('shown')) {
          this.hideAllSlideouts();
        } else {
          window.siteNavSlideoutShown = true;
          this.siteHeader.classList.add('nav-shown');
          list.classList.add('shown');

          this.siteHeader.classList.remove('has-shadow');
          list.classList.add('has-shadow');
        }
      });
    });

    document.body.addEventListener('click', (event) => {
      if (window.innerWidth < window.breakpoint.md_sh) { return; }
      if (!this.root.contains(event.target)) {
        this.hideAllSlideouts();
      }
    });
  }

  // Show/Hide Overlay

  showOverlay() {
    window.disableScrolling();
    window.siteNavMenuShown = true;
    this.root.classList.add('shown');

    setTimeout(() => {
      this.overlay.classList.add('opaque');
    }, 0);
  }

  hideOverlay() {
    this.overlay.classList.remove('opaque');

    setTimeout(() => {
      this.root.classList.remove('shown');
      window.siteNavMenuShown = false;
      window.enableScrolling();
    }, 500);
  }

  // Show/Hide Menu

  showMenu(event) {
    event.preventDefault();

    if (!this.root.classList.contains('shown')) {
      this.showOverlay();
    }

    setTimeout(() => {
      this.menu.classList.add('shown');
    }, 0);
  }

  hideMenu(event) {
    if (event) { event.preventDefault(); }

    this.menu.classList.remove('shown');
    this.hideOverlay();
  }

  // Show/Hide Slideout

  hideAllSlideouts() {
    let lists = this.root.querySelectorAll('.sn-item-a.has-children');
    if (lists.length > 0) {
      window.siteNavSlideoutShown = false;
      this.siteHeader.classList.remove('nav-shown');
      lists.forEach((list) => { list.classList.remove('shown'); });

      setTimeout(() => {
        this.siteHeader.classList.add('has-shadow');
        lists.forEach((list) => { list.classList.remove('has-shadow'); });
      }, 500);
    }
  }

  // Scroll

  scroll() {
    if (window.innerWidth < window.breakpoint.md_sh) { return; }
    this.hideAllSlideouts();
  }

  // Resize

  resize() {
    if (window.innerWidth < window.breakpoint.md_sh) {
      this.hideAllSlideouts();
    } else if (this.menu.classList.contains('shown')) {
      this.hideMenu();
    }
  }
}
